import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import customer from "../../assets/img/emre-altan.jpg"
import mockup from "../../assets/img/arcadium-mockup.png"
import eelbeyglu from "../../assets/img/teams/11.jpg"
import serife from "../../assets/img/teams/20.jpg"
import tugce from "../../assets/img/teams/03.png"
import simay from "../../assets/img/teams/08.jpg"
import video from "../../assets/img/arcadium-anneler-gunu.mp4"
import onay from "../../assets/img/teams/23.jpg"
import OtherCaseStudy from "../../components/other-case"




const ReferancesDetail = () => (
    <Layout>
        <SEO title="Arcadium Success Story | Flatart" />
        <div className="referances-detail py60 container">
            <div className="col-md-6 detail-left">
                <b>SUCCESS STORY</b>
                <h1>Arcadium</h1>
                <p>We have been providing social media management and blog services since December 2016 for Arcadium Shopping Mall, a local mall in Çayyolu, one of Ankara's most popular neighborhoods. Initially, a strategy was defined that suited the existing target audience of Arcadium Mall on social platforms.</p>
                <p>The company, active on Facebook, Instagram, Twitter, and YouTube under the username @arcadiumavm, has seen significant growth in follower count and reach metrics through the work carried out to date.</p>
                <p>While a 86% increase in follower count was observed on Arcadium Mall's Facebook, the number of Instagram followers grew 7-fold.</p>
                <p>Following the operations carried out, Arcadium Mall was able to reach an average of 800,000 people per month across social media platforms.</p>

            </div>
            <div className="col-md-6 referances-boxs">
                <div className="boxs">
                    <div className="box">
                        <span>%172</span>
                        <p>Revenue increase
within 2 years</p>
                    </div>
                    <div className="box">
                        <span>%150</span>
                        <p>Organic traffic increase<br />within 2 years.</p>
                    </div>

                </div>
                <div className="provided">
                    <h3>Services Provided</h3>
                    <div className="provided-box">
                        <div className="box">
                            <Link to="/search-engine-optimization/"></Link>
                            <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                                    <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                                    <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                                    <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                                </g>
                            </svg>
                            SEO
                        </div>
                        <div className="box">
                            <Link to="/social-media/"></Link>
                            <svg id="instagram-logo" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 61.312 61.312">
                                <path id="Path_36346" data-name="Path 36346" d="M44.392,0H16.92A16.939,16.939,0,0,0,0,16.92V44.392a16.939,16.939,0,0,0,16.92,16.92H44.392a16.939,16.939,0,0,0,16.92-16.92V16.92A16.939,16.939,0,0,0,44.392,0ZM55.872,44.392a11.493,11.493,0,0,1-11.48,11.48H16.92A11.493,11.493,0,0,1,5.44,44.392V16.92A11.493,11.493,0,0,1,16.92,5.44H44.392a11.493,11.493,0,0,1,11.48,11.48V44.392Z" />
                                <path id="Path_36347" data-name="Path 36347" d="M56.767,40.97a15.8,15.8,0,1,0,15.8,15.8A15.816,15.816,0,0,0,56.767,40.97Zm0,26.156A10.358,10.358,0,1,1,67.125,56.768,10.37,10.37,0,0,1,56.767,67.126Z" transform="translate(-26.111 -26.112)" />
                                <path id="Path_36348" data-name="Path 36348" d="M122.91,28.251a3.987,3.987,0,1,0,2.821,1.168A4,4,0,0,0,122.91,28.251Z" transform="translate(-75.793 -18.005)" />
                            </svg>
                            Social Media
                        </div>
                    </div>
                </div>
                <div className="project-details">
                    <h3>Impressum</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Brand Manager:</li>
                            <li>Digital Marketing Strategist:</li>
                            <li>Digital Ads:</li>
                            <li>SEO:</li>
                            <li>Website Development:</li>
                        </ul>
                        <ul>
                            <li><img src={simay} />Simay Akkurt</li>
                            <li><img src={eelbeyglu} alt="Alaattin Emre Elbeyoğlu" />Emre Elbeyoğlu</li>
                            <li><img src={serife} alt="Şerife Aytekin" />Şerife Aytekin</li>
                            <li><img src={tugce} alt="Tuğçe Gör" />Tuğçe Gör</li>
                            <li><img src={onay} alt="Barış Onay" />Barış Onay</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
        <div className="container">
            <div className="testimonial-customer" id="one">
                <p>"Thanks to our agency, which keeps up with social media trends, we can capture the pulse of our customers and deliver projects that captivate their interest."</p>
                <div className="author">
                    <div>
                        <img src={customer}></img>
                    </div>
                    <div className="author-name">
                        Emre Altan<br />
                        <span>CEO</span>
                    </div>
                </div>
            </div>




            <div className="customer-content pt60">
                <h2>650% organic traffic increase in 4 years.</h2>

                <p>Concept visuals and brand promotion content were created with "life-style" content at the forefront. The concepts named "From Within Life," "Arcadium Discovery," and "Arcadium Detail" are among the most successful examples.</p>
                <p>To increase reach and engagement, "Instant Win" competitions were held on Facebook, Twitter, and Instagram under the heading "Arcadium Gift of the Week." The "Instant Win" competitions, which received great interest from followers, were continued under various headings.</p>
                <h2>Arcadium Blog</h2>
                <p>A blog page was created on the website in line with the "life-style" content strategy. The blog, which publishes 4 pieces of content per month, currently receives an average of 5,000 visitors. It is also worth noting that a single piece of content has an average readership of 2,000.</p>

                <div className="site-preview" style={{ width: '100%', margin: '0px auto' }}>
                    <div style={{ width: '100%' }} className="mockup">
                        <img src={mockup} />
                    </div>
                </div>
                <h2>Mother's Day Campaign</h2>
                <p>Our project, which started on the digital platform for Mother's Day in May 2016, continued with events held inside the mall. For followers accustomed to "Instant Win" competitions, a Share-and-Win contest titled "Surprise Gift" was also organized on Facebook.</p>
                <p>"If a movie theater were yours, what would you say to your mother to celebrate Mother's Day?"</p>
                <p>Ten people selected from among the followers were asked to prepare short videos for their mothers. The mothers, upon learning they had been given movie tickets, met at Arcadium Cinemas for the same screening. Seeing their children's Mother's Day videos appear on the cinema screen was a priceless moment of smiling eyes and wonder.</p>
                <p>The project, supported by hidden camera footage from the cinema hall and a Facebook live broadcast, was received with great appreciation by followers.</p>
                <p>The video reached a total of 800,000 views across YouTube, Instagram, and Facebook.</p>

                <video width="70%" controls style={{ margin: '30px auto' }}>
                    <source src={video} type="video/mp4" />
                </video>

                <h2>Arcadium Beauty Days Vlog Project</h2>
                <p>In August 2017, a video content was produced in collaboration with renowned makeup vlogger @ojemrujumrimelim under the title "Building a Makeup Bag with 200 TL." The video was brought to life together with cosmetic brands located inside Arcadium Mall who met with their customers there. In parallel with the project, the "Arcadium Beauty Days" event was organized, featuring a lively conversation with popular vloggers.</p>
            </div>

        </div>


        <OtherCaseStudy />

        <Checkup />
    </Layout >
)

export default ReferancesDetail
